import React, { useMemo, useState } from 'react';
import { PlayerDataProps } from '@screens/players/types/player.data.props';
import DiffsComboBox from '@screens/players/player.details.tabs/diffs/diffs.combobox';
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { DiffsDatePickerStyled, DiffsLayout } from '@screens/players/player.details.tabs/diffs/diffs.combobox.styles';
import PlayerDiffsList from '@screens/players/player.details.tabs/diffs/player.diffs.list';
import { format } from 'date-fns';
import { DiffsFormData } from '@screens/players/player.details.tabs/diffs/diffs.form.data';

const PlayerDiffs = ({ player }: PlayerDataProps) => {
  const { pid } = player;
  const [category, setCategory] = useState('');
  const [gameType, setGameType] = useState('');

  const [from, setFrom] = useState<string | null>(null);
  const [to, setTo] = useState<string | null>(null);

  const dateModelFormat = 'yyyy-MM-dd HH:mm:ss';

  function handleDateFromChange(fromDate: Date | null) {
    setFrom(fromDate !== null ? format(fromDate, dateModelFormat) : null);
  }

  function handleDateToChange(toDate: Date | null) {
    setTo(toDate !== null ? format(toDate, dateModelFormat) : null);
  }

  const listProps = useMemo<DiffsFormData>(() => ({ pid, category, gameType, from, to }), [category, gameType, from, to]);

  return (
    <>
      <DiffsLayout>
        <DiffsComboBox onChange={setCategory} comboLabel='Category' by='CATEGORY' />
        <DiffsComboBox onChange={setGameType} comboLabel='Game Type' by='GAME_TYPE' />

        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DiffsDatePickerStyled>
            <DateTimePicker label='Start Date' value={from} onChange={handleDateFromChange} fullWidth />
          </DiffsDatePickerStyled>
          <DiffsDatePickerStyled>
            <DateTimePicker label='End Date' value={to} onChange={handleDateToChange} fullWidth />
          </DiffsDatePickerStyled>
        </MuiPickersUtilsProvider>
      </DiffsLayout>
      <PlayerDiffsList {...listProps} />
    </>
  );
};

export default PlayerDiffs;
